export enum GoogleAnalyticsPagePrefix {
  ColorFavorites = 'cfav_',
  ColorDetailsPage = 'cdp_',
  ColorFamilyPage = 'color_family_',
  ColorCollection = 'collection_',
}
